module.exports = __webpack_public_path__ + "img/a6850c4.jpg";